import React from 'react';
import { Bar } from 'react-chartjs-2';
import { FiltroSopSales, RepositorioSopSales } from '../../core/repositories/sopSalesRepositorio';
import { colorGraph, formatarDecimal, formatLargeNumber } from '../../core/utils/funcoes';
import { ChartData } from 'chart.js';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
// import './RevenueStackedBarChart.scss';


const SopSalesRevenueStackedBarChart: React.FC<{ filtro: FiltroSopSales }> = (props) => {

  const { mostrarToast } = useToast();
  const { t } = useTranslation();
  const [data, setData] = React.useState<ChartData<"bar">>({} as ChartData<"bar">);
  const [carregando, setCarregando] = React.useState(true);

  React.useEffect(() => {
    setCarregando(true);
    new RepositorioSopSales().getQuantity(props.filtro).then((res) => {
      const labels: string[] = [];
      const regions: (number | null)[] = [];
      var datasets: any[] = [];


      res.forEach((item: any) => {
        if (labels.indexOf(item.des_product_family) === -1)
          labels.push(item.des_product_family);
        if (regions.indexOf(item.des_region) === -1)
          regions.push(item.des_region);
      });
      for (let i = 0; i < regions.length; i++) {
        var aux = {
          label: regions[i],
          data: [] as (number | null)[],
          backgroundColor: colorGraph()[i],
        }
        for (let j = 0; j < labels.length; j++) {
          var valor = res.find((item: any) => item.des_product_family === labels[j] && item.des_region === regions[i]);
          if (valor) {
            aux.data.push(valor.hasOwnProperty('quantity') ? valor.quantity : null);
          } else {
            aux.data.push(null);
          }
        }
        datasets.push(aux);
      }

      console.log(datasets);

      setData({
        labels: labels,
        datasets: datasets
      });
      setCarregando(false);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }, [props.filtro]);


  // const data = {
  //   labels: ['Whey', 'Pre-workouts', 'Creatine', 'Protein Bars', 'Snacks', 'Protein Drinks', 'Vegetable'],
  //   datasets: [
  //     {
  //       label: 'Pacific',
  //       data: [1200, 900, 1400, 1000, 700, 300, 100],
  //       backgroundColor: '#4e73df',
  //     },
  //     {
  //       label: 'Mountain',
  //       data: [600, 400, 800, 600, 500, 200, 1900],
  //       backgroundColor: '#1cc88a',
  //     },
  //     {
  //       label: 'Central',
  //       data: [1500, 1200, 1800, 1600, 900, 400, 800],
  //       backgroundColor: '#36b9cc',
  //     },
  //     {
  //       label: 'Eastern',
  //       data: [300, 500, 400, 600, 700, 150, 600],
  //       backgroundColor: '#f6c23e',
  //     },

  //   ],
  // };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const value = context.parsed.y;
            return `${context.label}: ${formatarDecimal(value, props.filtro?.value !== "Quantity").replace("R$", props.filtro?.value !== "Quantity" ? "$" : "")}`;
          },
        },
      },

    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#333',
        },
      },
      y: {
        ticks: {
          color: '#333',
          callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
        },
        stacked: true,

        title: {
          display: true,
          text: props.filtro?.value !== "Quantity" ? 'Revenue (USD)' : 'Quantity',
          color: '#333',
          font: {
            weight: 'bold',
          },
        },
      },
    },
  };

  return (


    <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
      <strong className=" title-card">{props.filtro?.value !== "Quantity" ? 'Revenue' : 'Quantity'} by Region and Product Type</strong>
      {carregando ?
        <SopLoadingAnimation type="CHARTS" />
        :
          <Bar data={data} options={options} />
      }

    </div>
  );
};

export default SopSalesRevenueStackedBarChart;
